export default __webpack_public_path__ + "static/goldflowerpendant-7c7e4bb1a780b975d8836059bcf041df.png";